export default __webpack_public_path__ + "static/media/winning-trophy.0267df00.svg";